<template>
<div>
       <ServerError v-if="ServerError" />
       
     <v-snackbar v-model="showSnackBar" color="#FC4B4B" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

  <v-layout wrap justify-center  px-3  >
        
      <v-flex xs12 sm6 pt-10 >
        <v-card>
          <v-form ref="form">
          <v-layout wrap justify-center text-left py-5 pt-md-16 pa-6 >
              <v-flex xs12 text-center>
               <span class="sofiaPro" style="font-size:20px ; padding-bottom:8px; padding-right:20px; padding-left:20px;border-bottom:2px solid #0000001C">Bank Details</span>
              </v-flex>
               <v-flex xs12 >
                 <span style="" class="sofiaPro" >Bank</span>
       <v-text-field
          :rules="[rules.required]"
           outlined
           class="rounded"
           dense
          label="bank"
          v-model="bankdata.bank"
        >
        </v-text-field>
     </v-flex>
      <v-flex xs12 >
        <span class="sofiaPro">Account Holder</span>
       <v-text-field
        :rules="[rules.required]"
        outlined
           class="rounded"
           dense
          v-model="bankdata.accountHolder"
        
          label="Account Holder"
        >
        </v-text-field>
     </v-flex>
        <v-flex xs12 >
          <span class="sofiaPro">Account No</span>
       <v-text-field
        :rules="[rules.required]"
           outlined
           class="rounded"
           dense
          v-model="bankdata.accountNo"
          label="Account Number"
        >
        </v-text-field>
     </v-flex>
     
      <v-flex xs12 >
        <span class="sofiaPro">IFSC</span>
       <v-text-field
       :rules="[rules.required]"
          outlined
           class="rounded"
           dense
          v-model="bankdata.ifsc"
          label="IFSC"
        >
        </v-text-field>
     </v-flex>
      <v-flex xs12 >
        <span class="sofiaPro">Branch</span>
       <v-text-field
          :rules="[rules.required]"
           outlined
           class="rounded"
           dense
          v-model="bankdata.branch"
          label="Branch"
        >
        </v-text-field>
     </v-flex>
   
     <v-flex xs12  py-4>
         <v-btn  dark block color="#E31E24" @click="addbankdetail">
           Submit
         </v-btn>

     </v-flex>
          </v-layout>
           </v-form>
        </v-card>
      </v-flex>
  </v-layout>
</div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage"],

    data()
    {
        return{
            showSnackBar:false,
            msg:"",
            timeout:3000,
            bankdata:{
              branch:null,
              accountHolder:null,
              accountNo:null,
              ifsc:null,
              bank:null
            },
            ServerError:false,
                  rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 10 || "Max 10 digits",
        
      },
        }
    },
  //    computed: {
  //   bankdata() {
  //     if (this.bank) {
  //       return this.bank;
  //     } else return {};
  //   },
  // },
  mounted()
  {
    this.bankdata.branch = this.storage.bankDetails.branch;
    this.bankdata.accountHolder = this.storage.bankDetails.accountHolder;
    this.bankdata.accountNo = this.storage.bankDetails.accountNo;
    this.bankdata.ifsc = this.storage.bankDetails.ifsc;
    this.bankdata.bank = this.storage.bankDetails.bank;


  },
    methods:
    {

          addbankdetail() {
         if (this.$refs.form.validate()) {

        axios({
          method: "post",
          url: "seller/profile/level3",
        headers: {
          token: localStorage.getItem("token"),
        },
          data: this.bankdata,
        }).then((response) => {
          if (response.data.status) {
             this.msg =response.data.msg;
            this.showSnackBar = true;
             this.$emit("stepper", {
              level:3
            });

          } else {
            this.showSnackBar = true;
            this.msg = response.data.msg;
          }
          this.appLoading = false;
        })
        .catch((err) =>{
          console.log(err)
          this.ServerError =true
        })
         }
    },

    }
}
</script>
